import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4615cff9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-component" }
const _hoisted_2 = {
  for: "name",
  class: "flex font-normal mb-1"
}
const _hoisted_3 = { class: "px-2 form-message border-round-top flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "content ml-5" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "scheduled-message-date flex flex-column lg:col-4 sm:col-12" }
const _hoisted_7 = { class: "input-component" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "配信日時", -1))
const _hoisted_9 = { class: "form-time flex flex-column lg:col-4 sm:col-12" }
const _hoisted_10 = { class: "input-component" }
const _hoisted_11 = { class: "lg:col-6 sm:col-12 px-0" }
const _hoisted_12 = { class: "input-component" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "リンクURL", -1))
const _hoisted_14 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_15 = {
  key: 1,
  class: "p-error text-sm"
}
const _hoisted_16 = { class: "col-12 field grid flex-column px-0" }
const _hoisted_17 = { class: "input-component" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "image-url",
  class: "ml-2"
}, "イメージ画像 ", -1))
const _hoisted_19 = { class: "col-2 w-13rem upload-image" }
const _hoisted_20 = {
  key: 0,
  class: "card h-full relative border-1 surface-border"
}
const _hoisted_21 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "h-9rem w-full" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "h-auto w-full align-items-center justify-content-center" }
const _hoisted_28 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_29 = ["alt", "src"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "p-error text-sm"
}
const _hoisted_32 = { class: "grid mb-5" }
const _hoisted_33 = { class: "message-content flex flex-column col-12 input-component" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "メッセージ内容", -1))
const _hoisted_35 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_36 = { class: "dialog-footer grid mb-3" }
const _hoisted_37 = { class: "col-6 flex justify-content-center" }
const _hoisted_38 = { class: "col-6 flex justify-content-center" }

import Textarea from "primevue/textarea";
import Calendar from "primevue/calendar";
import FileUpload from "primevue/fileupload";
import { reactive, ref, watch, withDefaults } from "vue";
import { get, set, useDateFormat } from "@vueuse/core";
import { DATE_FORMAT, TIME_FORMAT } from "@/clinic/typings/constants/booking";
import { useToast } from "primevue/usetoast";
type ICampaignMessage = {
  index: number;
  number: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'message',
  props: {
    index: null,
    number: null
  },
  emits: ["updateDataMessage"],
  setup(__props: any, { emit: emits }) {

const props = __props as { index: number, number: number };


const visible = ref<boolean>(false);
const form = reactive({
  index: props.index,
  content: "",
  url: "",
  send_date: "",
  images: [],
});
const image = ref("");
const date = ref("");
const time = ref("");
const valueDateTime = ref();
const valueTitle = ref("未設定");
const toast = useToast();
const validateErrors = ref(false);
const showURLValidationError = ref(false);
const validateURL = () => {
  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  const isURLValid = urlPattern.test(get(form.url));
  set(showURLValidationError, !isURLValid && get(form.url) !== "");
};
const validatePresent = value => {
  return get(validateErrors) && (value == "" || value == null);
};
const validates = () => {
  set(validateErrors, false);

  if (get(showURLValidationError)) {
    set(validateErrors, true);
  }
  if (get(form.content) == "") {
    set(validateErrors, true);
  }

  return get(validateErrors);
};
const removeImage = async () => {
  set(image, "");
  set(form.images, undefined);
};
const imageName = ref("ファイルを添付する");
const inputUploadImage = ref();
const errorImageValidation = ref("");
const validateImage = () => {
  let reader = new FileReader();

  reader.readAsDataURL(get(inputUploadImage)?.files[0]);
  reader.onload = evt => {
    let img = new Image();
    img.onload = () => {
      if (get(inputUploadImage)?.files[0].size > 10000000) {
        toast.add({
          severity: "error",
          detail: "最大サイズファイル:10MB",
          life: 3000,
        });
        set(get(inputUploadImage), null);
        set(errorImageValidation, "最大サイズファイル:10MB");
        set(validateErrors, true);
      } else if (img.width >= 1024 || img.height >= 1024) {
        toast.add({
          severity: "error",
          detail: "高さ/幅 (ピクセル): 1024 未満",
          life: 3000,
        });
        set(get(inputUploadImage), null);
        set(errorImageValidation, "高さ/幅 (ピクセル): 1024 未満");
        set(validateErrors, true);
      } else {
        set(imageName, get(inputUploadImage)?.files[0]?.name);
        set(validateErrors, false);
      }
    };
    if (get(inputUploadImage)?.files?.length > 0) {
      img.src = evt.target.result;
      set(form.images, get(inputUploadImage)?.files);
      set(image, evt.target.result);
    }
  };
};


const onSubmit = async () => {
  if (validates() || get(errorImageValidation) !== "") {
    return;
  }
  // set(form.images, get(inputUploadImage)?.files);
  set(valueDateTime, form.send_date);
  set(valueTitle, form.content);
  emits("updateDataMessage", get(form), props.index);
  set(visible, false);
};
watch([date, time], ([newDate, newTime]) => {
  const date = useDateFormat(newDate, DATE_FORMAT);
  const time = useDateFormat(newTime, TIME_FORMAT);
  form.send_date = get(date) + " " + get(time);
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.number) + "回目", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(valueDateTime.value), 1),
      _createElementVNode("span", {
        class: "mr-2 icon icon-pencil-orange-svg text-right cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
      })
    ]),
    _createVNode(_component_InputText, {
      class: "border-top-none border-noround-top",
      readonly: "",
      value: valueTitle.value
    }, null, 8, ["value"]),
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: props.number + '回目',
      style: { width: '800px' },
      class: "mx-5",
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_unref(Calendar), {
                  class: "justify-content-end h-48 w-full",
                  showIcon: "",
                  modelValue: date.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
                  hourFormat: "24",
                  placeholder: "配送日",
                  dateFormat: "yy/mm/dd"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Calendar), {
                  class: "justify-content-end h-48 w-full",
                  placeholder: "配達時間",
                  modelValue: time.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((time).value = $event)),
                  timeOnly: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_InputText, {
                modelValue: form.url,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.url) = $event)),
                class: _normalizeClass(["input-text text-sm hover-border", { 'p-invalid': validatePresent(form.url) }]),
                placeholder: "URL",
                onInput: validateURL
              }, null, 8, ["modelValue", "class"]),
              (validatePresent(form.url))
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, " 必須項目です。 "))
                : (showURLValidationError.value)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_15, " 間違った形式。 "))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (image.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          role: "presentation",
                          src: image.value,
                          width: "150",
                          class: "shadow-2 mt-2 mb-2"
                        }, null, 8, _hoisted_22)
                      ]),
                      _createElementVNode("i", {
                        class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                        onClick: removeImage
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!image.value)
                  ? (_openBlock(), _createBlock(_unref(FileUpload), {
                      key: 1,
                      id: "upload",
                      class: "file-upload",
                      accept: "image/png, image/jpeg",
                      ref_key: "inputUploadImage",
                      ref: inputUploadImage,
                      onChange: validateImage,
                      type: "file",
                      fileLimit: 1
                    }, {
                      header: _withCtx(({ files, chooseCallback }) => [
                        _withDirectives(_createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            class: "fake-btn h-9rem w-full flex align-items-center justify-content-center",
                            onClick: ($event: any) => (chooseCallback())
                          }, _hoisted_26, 8, _hoisted_24)
                        ], 512), [
                          [_vShow, files.length <= 0]
                        ])
                      ]),
                      content: _withCtx(({ files, removeFileCallback }) => [
                        _withDirectives(_createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: file.name + file.type + file.size,
                              class: "card h-full relative border-1 surface-border"
                            }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("img", {
                                  role: "presentation",
                                  alt: file.name,
                                  src: file.objectURL,
                                  width: "150",
                                  class: "shadow-2 mt-2 mb-2"
                                }, null, 8, _hoisted_29)
                              ]),
                              _createElementVNode("i", {
                                class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                                onClick: 
                          () => {
                            removeFileCallback(index);
                            errorImageValidation.value = '';
                          }
                        
                              }, null, 8, _hoisted_30)
                            ]))
                          }), 128))
                        ], 512), [
                          [_vShow, files?.length > 0]
                        ])
                      ]),
                      _: 1
                    }, 512))
                  : _createCommentVNode("", true),
                (errorImageValidation.value != '')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(errorImageValidation.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_unref(Textarea), {
                modelValue: form.content,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.content) = $event)),
                class: _normalizeClass(["text-area mt-2 hover-border shadow-none", { 'p-invalid': validatePresent(form.content) }]),
                rows: "6",
                cols: "120"
              }, null, 8, ["modelValue", "class"]),
              (validatePresent(form.content))
                ? (_openBlock(), _createElementBlock("small", _hoisted_35, "メッセージを入力するか選択してください。"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_Button, {
              label: "閉じる",
              class: "p-button-light",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (visible.value = false))
            })
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_Button, {
              label: "設定する",
              onClick: onSubmit
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}
}

})